import { render } from "./hotline.vue?vue&type=template&id=1c2ed9a2&scoped=true&ts=true"
import script from "./hotline.vue?vue&type=script&lang=ts"
export * from "./hotline.vue?vue&type=script&lang=ts"

import "./hotline.vue?vue&type=style&index=0&id=1c2ed9a2&lang=stylus&scoped=true"

import exportComponent from "D:\\Front-end-project\\anxin-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c2ed9a2"]])

export default __exports__